export default __webpack_public_path__ + "static/media/product7.a3855e73.jpg";